import axios from "axios";
import ConfigHelper from "../config/Config";
import tokenHelper from "../helpers/tokenHelper";

const apiClient = axios.create({
  baseURL: ConfigHelper.getApiUrl(),
  withCredentials: true,
});

apiClient.interceptors.request.use((config) => {
  if (config.headers) {
    const token = tokenHelper.getToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      tokenHelper.removeToken();
      if (window.location.pathname !== "/") {
        window.location.href = "/";
      }
    }

    // Transijentni Network Error (nema odgovora): jedan tihi retry za GET.
    // Pokriva kratke prekide (npr. backend ~1min nedostupan tokom pm2 restarta)
    // da korisniku ne iskoci modal pri ulasku u aplikaciju. Samo idempotentni
    // GET, i samo jednom, da se POST-ovi ne bi duplirali.
    const cfg: any = error.config || {};
    const method = (cfg.method || "get").toLowerCase();
    if (!error.response && method === "get" && !cfg.__retried) {
      cfg.__retried = true;
      await new Promise((r) => setTimeout(r, 800));
      try {
        return await apiClient(cfg);
      } catch (retryError: any) {
        error = retryError;
      }
    }

    // Garantuj da error.response uvek postoji da catch handleri ne bi pucali
    if (!error.response) {
      error.response = {
        status: 0,
        data: {
          error: {
            message:
              error.message || "Greška u komunikaciji sa serverom",
          },
        },
      };
    } else if (!error.response.data?.error?.message) {
      error.response.data = error.response.data || {};
      error.response.data.error = error.response.data.error || {
        message: error.message || "Nepoznata greška",
      };
    }
    return Promise.reject(error);
  },
);

export default apiClient;
